export default __webpack_public_path__ + "static/media/P104.2.7f7fbf5e.mp3";